import React from "react"
import { Button, Col, Container, Row } from 'react-bootstrap'
import TableComponent from "../../../Table/Table";

export default function Fixedcommissions() {
    const columns = React.useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'currwcxency',
            },
            {
                Header: 'Type',
                accessor: 'currency',
            },
            {
                Header: 'Merchant',
                accessor: 'username',
            },
            {
                Header: 'Summ',
                accessor: 'email',
            },
            {
                Header: 'Added/Updated by',
                accessor: 'country',
            },
            {
                Header: 'Added/Updated by',
                accessor: 'registraddtiondate',
            },
            {
                Header: '',
                accessor: 'registrdationdate',
            },

        ],
        []
    );
    const columns1 = React.useMemo(
        () => [
            {
                Header: 'Currency',
                accessor: 'currwcxency',
            },
            {
                Header: 'Event Type',
                accessor: 'currency',
            },

            {
                Header: 'Summ',
                accessor: 'email',
            },
            {
                Header: 'Type',
                accessor: 'country',
            },
            {
                Header: 'Comment',
                accessor: 'registraddtiondate',
            },
            {
                Header: 'Event date',
                accessor: 'registrdationdate',
            },
            {
                Header: 'User name',
                accessor: 'registdqqfrdationdate',
            },

        ],
        []
    );
    return (
        <>
            <div>
                <div className="aff-grp-section-title">
                    Create Fixed comission for partner
                </div>
                <div className="main-pg-aff">
                    <div className="main-pg-aff-form">
                        <div className="aff-form-lbl">
                            Currency
                        </div>
                        <div className="main-pg-in">
                            <select style={{ width: "100%", padding: 5 }} >
                                <option>USD</option>
                            </select>
                        </div>
                    </div>
                    <div className="main-pg-aff-form">
                        <div className="aff-form-lbl">
                            Type
                        </div>
                        <div className="main-pg-in">
                            <select style={{ width: "100%", padding: 5 }} >
                                <option>Hybrid</option>
                            </select>
                        </div>
                    </div>
                    <div className="main-pg-aff-form">
                        <div className="aff-form-lbl">
                            Commission Summ
                        </div>
                        <div className="main-pg-in">
                            <input type="text" style={{ width: "100%", padding: 3 }} />

                        </div>
                    </div>
                    <div className="main-pg-aff-form">
                        <div className="aff-form-lbl">
                            Bonus description
                        </div>
                        <div className="main-pg-in">
                            <textarea style={{ width: "100%" }}></textarea>
                        </div>
                    </div>
                    <div className="main-pg-aff-fm" style={{ paddingTop: 15 ,paddingBottom:15}}>
                        <Button className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                        >
                            Create
                        </Button>
                    </div>
                </div>
                <div className='aff-grp-section-table-title'>
                    Fixed commissions
                </div>
                <div className='aff-grp-section-table'>
                    <div className="aff-dash-summary-table">
                        <TableComponent columns={columns} data={[]} hiddenPagination={true}/>
                    </div>
                </div>
                <div className='aff-grp-section-table-title'>
                    Logs
                </div>
                <div className='aff-grp-section-table'>
                    <div className="aff-dash-summary-table">
                        <TableComponent columns={columns1} data={[]}  hiddenPagination={true} />
                    </div>
                </div>
            </div>
        </>
    )
}